import Vue from 'vue';
import Router from 'vue-router';

import RouterComponent from './components/RouterComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "start" */ './views/main/Start.vue'),
      children: [
        {
          path: 'login',
          component: () => import('./views/Login.vue'),
        },
        {
          path: 'register',
          component: () => import('./views/Register.vue'),
        },
        {
          path: 'email-required',
          component: () => import('./views/EmailConfirmRequired.vue'),
        },
        {
          path: 'register/:promo',
          component: () => import('./views/Register.vue'),
        },
        {
          path: 'recover-password',
          component: () => import(/* webpackChunkName: "recover-password" */ './views/password_reset/PasswordRecovery.vue'),
        },
        {
          path: 'password-reset/:resetToken',
          component: () => import(/* webpackChunkName: "reset-password" */ './views/password_reset/PasswordReset.vue'),
        },
        {
          path: 'reset-credentials/:resetToken',
          component: () => import('./views/password_reset/ResetCredentials.vue'),
        },
        {
          path: '/',
          component: () => import('./views/main/MainStaff.vue'),
          children: [

            {
              path: 'staff-dashboard',
              component: () => import('./views/main/staff/StaffDashboard.vue'),
            },
            {
              path: 'staff-dashboard/view-as/:pk',
              component: () => import('./views/main/staff/StaffDashboard.vue'),
            },
            {
              path: 'staff/list',
              component: () => import('./views/main/tables/StaffTable.vue'),
            },
            {
              path: 'staff/tasks',
              component: () => import('./views/main/tables/TasksTable.vue'),
            },
            {
              path: 'staff/tasks/view-as/:pk',
              component: () => import('./views/main/tables/TasksTable.vue'),
            },
            {
              path: 'staff/tickets',
              component: () => import('./views/main/tables/TicketsTable.vue'),
            },
            {
              path: 'staff/tickets/view-as/:pk',
              component: () => import('./views/main/tables/TicketsTable.vue'),
            },
            {
              path: 'staff/users_imports',
              component: () => import('./views/main/staff/UsersImports.vue'),
            },
          ],
        },
        {
          path: '/',
          component: () => import(/* webpackChunkName: "main" */ './views/main/MainUsers.vue'),
          children: [
            {
              path: 'user/view-details/:pk',
              component: () => import('./views/main/team/ViewUserDetails.vue'),
            },
            {
              path: 'user/new-request/:ticketId',
              component: () => import('./components/UserTasks/Modals/NewLeadTaskModal.vue'),
            },
            {
              path: 'subscription',
              component: () => import('./views/main/subscription/Subscription.vue'),
            },
            {
              path: 'dashboard',
              component: () => import('./views/main/DashboardAlt.vue'),
            },
            {
              path: 'books',
              component: () => import('./views/main/courses/Books.vue'),
            },
            {
              path: 'books/:id',
              component: () => import('./views/main/courses/BookView.vue'),
            },
            {
              path: 'lessons',
              component: () => import('./views/main/courses/Categories.vue'),
            },
            {
              path: 'lessons/category/:id',
              component: () => import('./views/main/courses/Lessons.vue'),
            },
            {
              path: 'lesson/view/:id',
              component: () => import('./views/main/courses/LessonView.vue'),
            },
            {
              path: 'news',
              component: () => import('./views/main/news/News.vue'),
            },
            {
              path: 'news/view/:id',
              component: () => import('./views/main/news/NewsView.vue'),
            },
            // {
            //   path: 'courses',
            //   component: () => import('./views/main/courses/Courses.vue'),
            // },
            // {
            //   path: 'course/view/:id',
            //   component: () => import('./views/main/courses/CourseView.vue'),
            // },
            // {
            //   path: 'course/task/:id',
            //   component: () => import('./views/main/courses/CourseTask.vue'),
            // },
            // {
            //   path: 'course/preview/:id',
            //   component: () => import('./views/main/courses/CourseView.vue'),
            // },
            // {
            //   path: 'course/preview/task/:id',
            //   component: () => import('./views/main/courses/CourseTask.vue'),
            // },
            {
              path: 'team',
              component: () => import('./views/main/team/Team.vue'),
            },
            {
              path: 'contacts',
              component: () => import('./views/main/contacts/Contacts.vue'),
            },
            {
              path: 'flows',
              component: () => import('./views/main/user_flows/UserFlows.vue'),
            },
            {
              path: 'flows/edit_landing/:id',
              component: () => import('./views/main/user_flows/LandingEdit.vue'),
            },
            {
              path: 'events',
              component: () => import('./views/main/events/Events.vue'),
            },
            {
              path: 'events/view/:id',
              component: () => import('./views/main/events/EventView.vue'),
            },
            {
              path: 'profile',
              component: RouterComponent,
              redirect: 'profile/view',
              children: [
                {
                  path: 'view',
                  component: () => import(
                    /* webpackChunkName: "main-profile" */ './views/main/profile/UserProfileAlt.vue'),
                },
                {
                  path: 'edit',
                  component: () => import(
                    /* webpackChunkName: "main-profile-edit" */ './views/main/profile/UserProfileEditAlt.vue'),
                },
                {
                  path: 'settings',
                  component: () => import(
                    /* webpackChunkName: "main-profile-password" */ './views/main/profile/UserProfileSettings.vue'),
                },
                {
                  path: 'password',
                  component: () => import(
                    /* webpackChunkName: "main-profile-password" */ './views/main/profile/UserProfileEditPassword.vue'),
                },
              ],
            },
          ],
        },
        // {
        //   path: 'main',
        //   component: () => import(/* webpackChunkName: "main" */ './views/main/Main.vue'),
        //   children: [
        //     {
        //       path: 'admin',
        //       component: () => import(/* webpackChunkName: "main-admin" */ './views/main/admin/Admin.vue'),
        //       redirect: 'admin/users/all',
        //       children: [
        //         {
        //           path: 'users',
        //           redirect: 'users/all',
        //         },
        //         {
        //           path: 'users/all',
        //           component: () => import(
        //             /* webpackChunkName: "main-admin-users" */ './views/main/admin/AdminUsers.vue'),
        //         },
        //         {
        //           path: 'users/edit/:id',
        //           name: 'main-admin-users-edit',
        //           component: () => import(
        //             /* webpackChunkName: "main-admin-users-edit" */ './views/main/admin/EditUser.vue'),
        //         },
        //         {
        //           path: 'users/create',
        //           name: 'main-admin-users-create',
        //           component: () => import(
        //             /* webpackChunkName: "main-admin-users-create" */ './views/main/admin/CreateUser.vue'),
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
    },
    {
      path: '/*', redirect: '/',
    },
  ],
});
